// A value as the inside of a double-quoted CSS attribute selector, e.g.
// `td[data-field="${escapeAttributeValue(field)}"]`.
export function escapeAttributeValue(value) {
    return String(value).replace(/["\\]/g, '\\$&');
}
